import { FC, useCallback } from 'react';
import { IResponseProductExclusion } from 'src/types/products';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';

interface IProps {
  exclusion: IResponseProductExclusion;
  onChangeExclusions: (id: number) => void;
}

const ProductExclusion: FC<IProps> = ({ exclusion, ...props }: IProps): JSX.Element => {
  const onSelect = useCallback(() => {
    props.onChangeExclusions(exclusion.id);
  }, [exclusion]);

  return <Checkbox name={exclusion.id} value={exclusion.selected} label={exclusion.name} onClick={onSelect} labelClassName="text-break" />;
};

export default ProductExclusion;
